import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AslibModalComponent, AslibModalService } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { ModalManagerHelper } from '../../shared/helpers/modal-manager-helper';
import { AslibLoadingService } from '@aslib/loading';
import { ShowFile } from '../../shared/helpers/show-file';
import { Messages } from '../../shared/helpers/mensages';
import { ImportarPlanilhaIpmService } from './shared/service/importar-planilha-ipm.service';
import { Ano } from './../../consulta/distribuicao-mensal-aos-municipio/shared/model/distribuicaoMensalMunicipio.model';

@Component({
  selector: 'sarf-importar-planilha-ipm',
  templateUrl: './importar-planilha-ipm.component.html'
})

export class ImportarPlanilhaIpmComponent implements OnInit {
  subscription: Subscription;
  observerOnIniftFormulario: Subscription;
  showFile: ShowFile;
  aslibModal: AslibModalComponent;
  anoSelected : Ano;
  listaAno : Ano[];
  DataInicio: Date;
  @ViewChild(AslibModalComponent) modalMensagem: AslibModalComponent;
  @ViewChild('fileInput') fileInput : any;

  constructor(

    private readonly modalManagerHelper: ModalManagerHelper,
    private readonly _aslibLoadingService: AslibLoadingService,
    private readonly _aslibModalService: AslibModalService,
    private readonly _messages : Messages,
    private readonly _importarPlanilhaIpmService : ImportarPlanilhaIpmService
  ) {
    modalManagerHelper.parent = this;
    this.showFile= new ShowFile();
  }

  formImprtarPlanilha = new FormGroup({
    AnoReferencia: new FormControl(undefined, Validators.required),
    anoReferencia: new FormControl(undefined)
  });

  ngOnInit() {
    this.listarAno();
 
  }

  ImportarPlanilhaIpm(modal: AslibModalComponent) {
    const formData = new FormData();
    formData.append('upload', this.fileInput.nativeElement.files[0]);
    formData.append('ano', this.anoSelected.IdAno);

    this._importarPlanilhaIpmService.ImportarPlanilhaIpm(formData).subscribe(
      retornoRequest =>{

        if(retornoRequest.objetoMensagem &&  retornoRequest.objetoMensagem.Mensagem !== null &&  retornoRequest.objetoMensagem.Mensagem !== ''){
         this.modalManagerHelper.modalMensagem(modal, retornoRequest.objetoMensagem);
        }
      }
    )
  }

  listarAno (){

      const AnoSeguinte =  (new Date().getFullYear() + 1).toString();
      const AnoAtual =  (new Date().getFullYear() ).toString();
      const AnoAnterior =  (new Date().getFullYear() -1 ).toString();

        this.listaAno =
        [
          {Descricao: AnoSeguinte, IdAno: AnoSeguinte},
          {Descricao: AnoAtual, IdAno: AnoAtual},
          {Descricao: AnoAnterior, IdAno: AnoAnterior}
        ];

        this.anoSelected = this.listaAno[0];
  }

  unSubscribe() {
    this._aslibLoadingService.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/ipm/importacao-planilha-ipm/importar-planilha-ipm.component.ts